import { ComponentSettings } from './types';

export const defaultSettings: ComponentSettings = {
  customerProfile: {
    editAllowed: null,
    customerDataVisibleFields: [
      'address',
      'address2',
      'city',
      'state',
      'zip',
      'firstName',
      'lastName',
      'email',
      'ccEmails',
      'organization',
      'vatNumber',
      'phoneNumber',
      'country',
      'state',
    ],
  },
};
